import React from "react";

import { PopoverContentProps } from "@radix-ui/react-popover";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import {
  FunctionalCard,
  FunctionalCardContent,
  FunctionalCardHeader,
} from "@/components/molecules/cards/FunctionalCard";
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from "@/components/molecules/Popover";
import QuestionIcon from "@/icons/__generated__/Question/Question16";
import XIcon from "@/icons/__generated__/X/X16";

interface QuestionMarkTooltipProps {
  children: React.ReactNode;
  title: React.ReactNode;
  align?: PopoverContentProps["align"];
}

export const QuestionMarkTooltip: React.FC<QuestionMarkTooltipProps> = ({
  children,
  title,
  align = "start",
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger className="tw-flex">
        <QuestionIcon />
      </PopoverTrigger>
      <PopoverContent side="top" align={align}>
        <FunctionalCard className="tw-border-0 tw-w-full sm:tw-w-[225px]">
          <FunctionalCardHeader
            className="sm:tw-border-b-0"
            closeButton={
              <Button
                variant="text-only"
                iconOnly={true}
                onClick={() => setIsOpen(false)}
              >
                <XIcon />
              </Button>
            }
          >
            <Text typeface="body-1-m">{title}</Text>
          </FunctionalCardHeader>
          <FunctionalCardContent className="sm:tw-pt-8">
            <Text element="div" typeface="body-1" className="tw-text-gray-900">
              {children}
            </Text>
          </FunctionalCardContent>
        </FunctionalCard>

        <PopoverArrow className="tw-fill-base-white" width={20} height={10} />
      </PopoverContent>
    </Popover>
  );
};
